import { useMutation, useInfiniteQuery } from "@tanstack/react-query"
import {
  submitCustomerFeedback,
  getCustomerFeedbacks,
} from "../api/customerFeedback"

export const useSubmitCustomerFeedback = () =>
  useMutation({
    mutationFn: submitCustomerFeedback,
    onError: (error) => {
      console.error("Failed to submit feedback:", error)
    },
  })

export const useAllCustomerFeedbacks = ({ limit = 20, sortBy, filters }) =>
  useInfiniteQuery({
    queryKey: ["allCustomerFeedbacks", "infinite", sortBy, filters],
    queryFn: ({ pageParam = 0 }) =>
      getCustomerFeedbacks({
        offset: pageParam,
        limit,
        sortBy,
        ...filters,
      }),
    getNextPageParam: (lastPage, allPages) => {
      const loadedItems = allPages.reduce(
        (sum, page) => sum + page.data.length,
        0
      )

      return lastPage.data.length === limit ? loadedItems : undefined
    },
    initialPageParam: 0,
    retry: 0,
    staleTime: 0,
    refetchInterval: 1 * 60 * 1000,
    select: (data) => {
      const lastPage = data?.pages?.[data?.pages?.length - 1]
      const flattenedData = data?.pages?.flatMap((page) => page.data) || []

      return {
        data: flattenedData,
        total: lastPage?.total || 0,
        perPage: lastPage?.perPage || limit,
      }
    },
  })
